export function scrollToSection(id: string): void {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.25 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function scrollToTop(): void {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(0, { duration: 1.25 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
}
